module.exports = __webpack_public_path__ + "assets/img/sort-alpha.205ba2f1.svg";